import { useMemo } from 'react'

type InsuranceParams = {
  cargoName: string
  costOfCargo: number
  isRefRisk?: boolean
  isBroken?: boolean
  hasFranchise?: boolean
}

const TARIFFS: Record<string, number> = {
  'автомобили, шины': 0.0015,
  'шины, запасные части к автомобилям': 0.0006,
  'бумага, бумажные изделия, макулатура': 0.0006,
  'бытовая техника, электроника, оргтехника': 0.0006,
  'медикаменты без температурного режима': 0.0006,
  'запчасти и аксессуары к автомобилям': 0.0006,
  'строительные и отделочные материалы, инструменты': 0.0006,
  'косметика и парфюмерия, бытовая химия': 0.0006,
  'мебель, предметы интерьера': 0.0006,
  'товары народного потребления': 0.0006,
  'игрушки, детские товары, спортивный инвентарь': 0.0006,
  оборудование: 0.0006,
  'медицинская техника, инструменты, изделия': 0.0006,
  'металл и изделия из металла': 0.0006,
  'химические продукты, неопасные': 0.0006,
  'продукты питания, напитки': 0.0006,
}

const getTariffByCargoName = (cargoName: string): number => {
  const lower = cargoName.toLowerCase()
  const match = Object.entries(TARIFFS).find(([key]) => lower.includes(key.toLowerCase()))
  return match ? match[1] : 0
}

export const useInsuranceCalculator = ({ cargoName, costOfCargo, isRefRisk = false, isBroken = false, hasFranchise = true }: InsuranceParams) => {
  return useMemo(() => {
    const tariff = getTariffByCargoName(cargoName)
    if (tariff === 0) {
      return {
        tariff,
        coeffRef: 0,
        coeffBroken: 0,
        coeffFranchise: 0,
        totalCoeff: 0,
        insuranceCost: null,
      }
    }

    const coeffRef = isRefRisk ? 1.2 : 1
    const coeffBroken = isBroken ? 1.03 : 1
    const coeffFranchise = hasFranchise ? 1 : 1
    const totalCoeff = coeffRef * coeffBroken * coeffFranchise

    const insuranceCost = Math.ceil(costOfCargo * tariff * totalCoeff)

    return {
      tariff,
      coeffRef,
      coeffBroken,
      coeffFranchise,
      totalCoeff,
      insuranceCost,
    }
  }, [cargoName, costOfCargo, isRefRisk, isBroken, hasFranchise])
}
